import React from 'react';
import OnboardingTour from '../shared/onboarding/OnboardingTour';

export default function CalendarViewTour() {
  return (
    <OnboardingTour
      tourId="CalendarTasksView"
      steps={[
        {
          selector: '[data-testid="export-for-ical-button"]',
          content: ' Link your Nekst tasks to your Google, Outlook, iOS or other online calendar.',
        },
        {
          selector: '.nekst-dropdown__control',
          content: (
            <div>
              <p>Switch between Month and Weekly task views.</p>
              <img src="/img/img_switch_calendar_view.png" alt="Switch Calendar View" />
            </div>
          ),
        },
      ]}
    />
  );
}
